export default __webpack_public_path__ + "a00731d145bde3e56507ffe2598dd113.png";